export type DropdownItemProps = {
    children: string;
    spacing?: "cozy" | "compact";
    autoFocus?: boolean;
};

export type DropdownMenuItemPlacement =
    | "auto-start"
    | "auto"
    | "auto-end"
    | "top-start"
    | "top"
    | "top-end"
    | "right-start"
    | "right"
    | "right-end"
    | "bottom-end"
    | "bottom"
    | "bottom-start"
    | "left-end"
    | "left"
    | "left-start";

export const mapPlacementToAnchor = (placement?: DropdownMenuItemPlacement): string => {
    if (!placement || placement === "auto") return "bottom start";

    const mapping: Record<DropdownMenuItemPlacement, string> = {
        "auto-start": "bottom start",
        auto: "bottom start",
        "auto-end": "bottom end",
        "top-start": "top start",
        top: "top",
        "top-end": "top end",
        "right-start": "right start",
        right: "right",
        "right-end": "right end",
        "bottom-end": "bottom end",
        bottom: "bottom",
        "bottom-start": "bottom start",
        "left-end": "left end",
        left: "left",
        "left-start": "left start",
    };

    return mapping[placement];
};

export type SelectOptionProps = {
    id: string;
    label: string;
    [key: string]: unknown;
};

/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */
export const COLLAPSE_ELEM_BEFORE: unique symbol = Symbol('collapse-elem-before');
export type COLLAPSE_ELEM_BEFORE_TYPE = typeof COLLAPSE_ELEM_BEFORE;